export default "__VITE_ASSET__CaU1D9oH__ 57w";